export enum UserRoleOfCountyGuildRoom {
  CountyGuildRoomManager = 3,
  CountySecretariat = 15,
  CountyTreasurer = 16,
  CountyGuildRoomViceManager = 1009,
  CountyGuildRoomExecutiveManager = 1010,
}
